//#region Table
export const columnList = [
    {
        field: 'consultationContent',
        header: 'Consultation',
        body: rowData => rowData?.consultationContent || '-',
        initialShown: true,
    },
    {
        field: 'mriContent',
        header: 'MRI',
        body: rowData => rowData?.mriContent || '-',
        initialShown: true,
    },
    {
        field: 'ctScanContent',
        header: 'CT Scan',
        body: rowData => rowData?.ctScanContent || '-',
        initialShown: true,
    },
    {
        field: 'pathologyContent',
        header: 'Pathology',
        body: rowData => rowData?.pathologyContent || '-',
        initialShown: true,
    },
    {
        field: 'opticalContent',
        header: 'Optical',
        body: rowData => rowData?.opticalContent || '-',
        initialShown: true,
    },
    {
        field: 'audiologyContent',
        header: 'Audiology',
        body: rowData => rowData?.audiologyContent || '-',
        initialShown: true,
    },
    {
        field: 'stockholmContent',
        header: 'Stockholm',
        body: rowData => rowData?.stockholmContent || '-',
        initialShown: true,
    },
    {
        field: 'bloodsTestsCount',
        header: 'Bloods Tests Count',
        body: rowData => {
            return (
                <div
                    className="overflow-dot overflow-text-2"
                    style={{width: '100%'}}>
                    {rowData?.bloodsTestsCount
                        ? `${rowData?.bloodsTestsCount} (${rowData[
                              'bloodsTestsCountValue'
                          ].join(', ')})`
                        : 'No Examinations'}
                </div>
            )
        },
        initialShown: true,
    },
    {
        field: 'otherTestsCount',
        header: 'Other Tests Count',
        body: rowData => {
            return (
                <div
                    className="overflow-dot overflow-text-2"
                    style={{width: '100%'}}>
                    {rowData?.otherTestsCount
                        ? `${rowData?.otherTestsCount} (${rowData[
                              'otherTestsCountValue'
                          ].join(', ')})`
                        : 'No Examinations'}
                </div>
            )
        },

        initialShown: true,
    },
    {
        field: 'radiologyCount',
        header: 'Radiology Count',
        body: rowData => {
            return (
                <div
                    className="overflow-dot overflow-text-2"
                    style={{width: '100%'}}>
                    {rowData?.radiologyCount
                        ? `${rowData?.radiologyCount} (${rowData[
                              'radiologyCountValue'
                          ].join(', ')})`
                        : 'No Examinations'}
                </div>
            )
        },
        initialShown: true,
    },
    {field: 'createdAt', header: 'Created At', initialShown: true},
]
//#endregion
